import React from 'react';
import { Navbar } from '../components/Navbar';
import { ResearchPage } from '../components/ResearchPage';
import { Footer } from '../components/Footer';
export const Research = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2365">
      <Navbar data-id="element-2366" />
      <ResearchPage data-id="element-2367" />
      <Footer data-id="element-2368" />
    </div>;
};